<template>
    <el-dialog
        :width="dialogConfig.width"
        :visible="true"
        :append-to-body="true"
        :close-on-click-modal="false"
        :close-on-press-escape="false"
        :before-close="beforeClose"
        :custom-class="'performanceSignInDialog'"
        top="5vh"
    >
        <div slot="title">
            <div class="header-title">
                <span
                    @click="handleChangeView('sign')"
                    :class="currentView === 'sign' ? 'activeClass' : ''"
                    >{{ dialogConfig.dialogTitle }}</span
                >
                <span
                    v-if="false"
                    @click="handleChangeView('suNingSign')"
                    :class="currentView === 'suNingSign' ? 'activeClass' : ''"
                    >苏宁采购入库详情</span
                >
                <span
                    v-if="false"
                    @click="handleChangeView('userSignInDetail')"
                    :class="
                        currentView === 'userSignInDetail' ? 'activeClass' : ''
                    "
                    >用户签收详情</span
                >
                <span
                    v-if="false"
                    @click="handleChangeView('netSignInDetail')"
                    :class="
                        currentView === 'netSignInDetail' ? 'activeClass' : ''
                    "
                    >网点配送详情</span
                >
                <span
                    v-if="false"
                    @click="handleChangeView('warehouseData')"
                    :class="
                        currentView === 'warehouseData' ? 'activeClass' : ''
                    "
                    >入库数据</span
                >
                <span
                    v-if="false"
                    @click="handleChangeView('IllegalUnload')"
                    :class="
                        currentView === 'IllegalUnload' ? 'activeClass' : ''
                    "
                    >违规卸货</span
                >
            </div>
        </div>
        <SuNingDetail v-if="currentView === 'suNingSign'" :rowData="rowData"></SuNingDetail>

        <!-- 用户签收详情 -->
        <user-sign-in-detail v-if="currentView === 'userSignInDetail'" :rowData="rowData"></user-sign-in-detail>
        <!-- 网点配送详情 -->
        <net-sign-in-detail v-if="currentView === 'netSignInDetail'" :rowData="rowData"></net-sign-in-detail>
        <!-- 入库数据 -->
        <warehouse-data v-if="currentView === 'warehouseData'" :dataInfo="warehouseDataInfo"></warehouse-data>
        <!-- 违规卸货 -->
        <Illegal-unload
            v-if="currentView === 'IllegalUnload'"
            ref="IllegalUnload"
            :rowData="rowData"
        ></Illegal-unload>
        <div
            v-show="currentView === 'sign'"
            class="signContent"
            v-loading="signLoading"
        >
            <div class="signLeft">
                <p class="upload-top-title" v-if="CNStateSubsidies">全部回单</p>
                <receipt-upload
                    ref="receiptUpload"
                    :attachmentList="attachmentList"
                    :rowData="rowData"
                    :loading="attachmentLoading"
                    :operateType="dialogConfig.operateType"
                    @delete-success="deleteReceiptImageSuccess"
                    @upload-success="uploadReceiptImageSuccess"
                >
                    <template #good-list="{ height }">
                        <sign-in-table
                            v-if="dialogConfig.operateType !== OPERATE_TYPE.SIGN_PUSH && viewStatus === '1'"
                            :rowData="rowData"
                            :kaType="receiptInfo.kaType"
                            :tableDataList="tableDataList"
                            :operateType="dialogConfig.operateType"
                            :height="height"
                            @setCount="getCount"
                        ></sign-in-table>

                        <B2B-sign-in-table
                            v-if="dialogConfig.operateType !== OPERATE_TYPE.SIGN_PUSH && viewStatus === '2'"
                            :rowData="rowData"
                            :tableDataList="tableDataList"
                            :operateType="dialogConfig.operateType"
                            :height="height"
                            @setCount="getCount"
                        ></B2B-sign-in-table>

                        <B2C-sign-in-table
                            v-if="dialogConfig.operateType === OPERATE_TYPE.SIGN_PUSH || viewStatus === '3'"
                            :rowData="rowData"
                            :tableDataList="tableDataList"
                            :operateType="dialogConfig.operateType"
                            :height="height"
                            @setCount="getCount"
                        ></B2C-sign-in-table>

                        <CN-sign-in-table
                            v-if="dialogConfig.operateType !== OPERATE_TYPE.SIGN_PUSH && viewStatus === '4'"
                            :rowData="rowData"
                            :tableDataList="tableDataList"
                            :operateType="dialogConfig.operateType"
                            :height="height"
                            @setCount="getCount"
                        ></CN-sign-in-table>
                    </template>
                </receipt-upload>

                <p class="upload-top-title" v-if="CNStateSubsidies">SN码</p>
                <sn-upload
                    ref="snUpload"
                    v-if="CNStateSubsidies"
                    :attachmentList="snUploadList"
                    :rowData="rowData"
                    :loading="attachmentLoading"
                    :operateType="dialogConfig.operateType"
                    @delete-success="deleteReceiptImageSuccess"
                    @upload-success="uploadReceiptImageSuccess"
                ></sn-upload>

                <p class="upload-top-title" v-if="CNStateSubsidies">货物正面照</p>
                <goods-upload
                    ref="goodsUpload"
                    v-if="CNStateSubsidies"
                    :attachmentList="goodsUploadList"
                    :rowData="rowData"
                    :loading="attachmentLoading"
                    :operateType="dialogConfig.operateType"
                    @delete-success="deleteReceiptImageSuccess"
                    @upload-success="uploadReceiptImageSuccess"
                ></goods-upload>

                <!-- 回单印鉴 -->
                <sign-ask
                    ref="signAsk"
                    v-if="receiptSealInfo"
                    :receiptSealInfo="receiptSealInfo"
                ></sign-ask>
            </div>
            <div class="signRight">
                <sign-in-form
                    ref="signInForm"
                    :isChargeEdit="dialogConfig.isChargeEdit"
                    :rowData="rowData"
                    :goodsList="goodsList"
                    :viewStatus="viewStatus"
                    @changeFlag="changeFlag"
                ></sign-in-form>

                <div
                    class="tip-warning"
                    v-if="dialogConfig.operateType === OPERATE_TYPE.SIGN_PUSH"
                >
                    <p> <strong>目前重推功能暂不支持以下情况进行重推：</strong> </p>
                    <p>1、已经重推过的不允许重推；</p>
                    <p>2、第一次签收有短少的单据不允许重推；</p>
                    <p>3、不允许短少改签收或短少改拒收进行重推，允许签收改短少或者拒收改短少；</p>
                    <p>4、基地业务的生活事业部和微清事业部订单商品行的机损拒收和以及厨热事业部订单商品行的箱损拒收和机损拒收视作短少回传客户，不允许改成签收或拒收重推。</p>
                </div>

                <sign-in-table
                    v-if="dialogConfig.operateType !== OPERATE_TYPE.SIGN_PUSH && viewStatus === '1'"
                    ref="signInTable"
                    :rowData="rowData"
                    :kaType="receiptInfo.kaType"
                    :tableDataList="tableDataList"
                    :operateType="dialogConfig.operateType"
                    @setCount="getCount"
                ></sign-in-table>

                <B2B-sign-in-table
                    v-if="dialogConfig.operateType !== OPERATE_TYPE.SIGN_PUSH && viewStatus === '2'"
                    ref="B2BSignInTable"
                    :rowData="rowData"
                    :tableDataList="tableDataList"
                    :operateType="dialogConfig.operateType"
                    @setCount="getCount"
                ></B2B-sign-in-table>

                <B2C-sign-in-table
                    v-if="dialogConfig.operateType === OPERATE_TYPE.SIGN_PUSH || viewStatus === '3'"
                    ref="B2CSignInTable"
                    :rowData="rowData"
                    :tableDataList="tableDataList"
                    :operateType="dialogConfig.operateType"
                    @setCount="getCount"
                ></B2C-sign-in-table>

                <CN-sign-in-table
                    v-if="dialogConfig.operateType !== OPERATE_TYPE.SIGN_PUSH && viewStatus === '4'"
                    ref="CNSignInTable"
                    :rowData="rowData"
                    :tableDataList="tableDataList"
                    :operateType="dialogConfig.operateType"
                    @setCount="getCount"
                ></CN-sign-in-table>
            </div>
        </div>
        <template #footer>
            <div v-show="currentView === 'sign' || 'netSignInDetail'">
                <el-button @click="beforeClose">取消</el-button>
                <!-- 签收时显示 -->
                <el-button
                    type="primary"
                    :loading="btnLoading"
                    v-if="dialogConfig.operateType === OPERATE_TYPE.SIGN_COMFIRM && currentView !== 'IllegalUnload'"
                    @click="handleSignComfirm"
                    >签收确认</el-button
                >
                <!-- 拒收时显示 -->
                <el-button
                    type="primary"
                    :loading="btnLoading"
                    v-if="dialogConfig.operateType === OPERATE_TYPE.REJECT_COMFIRM && currentView !== 'IllegalUnload'"
                    @click="handleRejectComfirm"
                    >拒收确认</el-button
                >
                <!-- 重推时显示 -->
                <el-button
                    type="primary"
                    :loading="btnLoading"
                    v-if="dialogConfig.operateType === OPERATE_TYPE.SIGN_PUSH"
                    @click="handleSignPushComfirm"
                    >重推确认</el-button
                >
                <!-- 增值费修改时显示 -->
                <el-button
                    type="primary"
                    :loading="btnLoading"
                    v-if="
                        dialogConfig.isChargeEdit === 1 &&
                        dialogConfig.operateType !== OPERATE_TYPE.SIGN_COMFIRM
                    "
                    @click="handleChargeEdit"
                    >增值费修改</el-button
                >
                <!-- 违规卸货展示 -->
                <el-button
                    type="primary"
                    :loading="btnLoading"
                    v-if="currentView === 'IllegalUnload'"
                    @click="handleIllegalUnload"
                    >保存</el-button
                >
            </div>
        </template>
    </el-dialog>
</template>
<script>
import SignInForm from './SignInForm.vue';
import SignInTable from './SignInTable.vue';
import B2BSignInTable from './B2BSignInTable.vue';
import B2CSignInTable from './B2CSignInTable.vue';
import CNSignInTable from './CNSignInTable.vue';
import ReceiptUpload from '../ReceiptUpload.vue';
import snUpload from '../snUpload.vue';
import goodsUpload from '../goodsFrontUpload.vue';
import SuNingDetail from './SuNingDetail';
import SignAsk from './component/signAsk';
import UserSignInDetail from './component/userSignInDetail/Index';
import NetSignInDetail from './component/netSignInDetail/Index';
import WarehouseData from './component/warehouseData/Index';
import IllegalUnload from './component/IllegalUnload/Index';
import { mapState } from 'vuex';
import { attachmentEntity } from '../../entity.js';
import {
    getReceiptSignDetailInfo,
    queryReceiptDetailByTaskNo,
    receiptSign,
    receiptRejectSign,
    signPush,
    illegalUnloadUpdate,
    queryWarehouseData,
    updateCharge
} from '@/modules/transport/otp/api/performanceReceiptSign.js';
import { queryByTaskNo } from '@/modules/transport/otp/api/performanceReceiptBackCheck';
import { OPERATE_TYPE, SIGN_STATUS } from '../utils/constant.js';
import { formatSingleSignRequestParams, validateSignComfirm } from './util.js';

export default {
    name: 'signInDialog',
    components: {
        SignAsk,
        ReceiptUpload,
        snUpload,
        goodsUpload,
        SignInForm,
        SignInTable,
        B2BSignInTable,
        B2CSignInTable,
        CNSignInTable,
        SuNingDetail,
        UserSignInDetail,
        NetSignInDetail,
        WarehouseData,
        IllegalUnload
    },
    props: {
        rowData: {
            type: Object,
            default () {
                return {};
            }
        },
        dialogConfig: {
            type: Object,
            default () {
                return {};
            }
        },
        dictData: {
            type: Object,
            default () {
                return {};
            }
        }
    },
    data () {
        return {
            OPERATE_TYPE,
            viewStatus: '', // table组件展示标识
            btnLoading: false, // 签收、拒收确认按钮加载动画
            attachmentLoading: false,
            receiptSealInfo: null,
            receiptInfo: {}, // 回单签收表单信息
            attachmentList: [], // 附件列表
            snUploadList: [], // SN码附件列表
            goodsUploadList: [], // 货物正面照附件列表
            tagList: [],
            goodsList: [],
            currentView: 'sign',
            signLoading: false,
            warehouseDataInfo: {}, // 入库数据信息
            tableDataList: [], // table组件参数
            componentChange: {
                1: 'signInTable',
                2: 'B2BSignInTable',
                3: 'B2CSignInTable',
                4: 'CNSignInTable'
            } // table组件名称标识
        };
    },
    computed: {
        ...mapState(['user']),
        userSignInDetail () {
            const userSignOrderType = Object.keys(this.dictData.USER_SIGNIN_DETAILS);
            if (
                ['CCS', 'CIMS', 'OFC', 'MRP'].includes(this.rowData.sourceSystem) &&
                this.rowData.businessMode === 'B2C' &&
                this.rowData.distributionLastFlag === 'Y' &&
                userSignOrderType.includes(this.rowData.orderType) &&
                this.rowData.inOutType === 'OUT'
            ) {
                return true;
            }
            return false;
        },
        netSignInDetail () {
            const netSignOrderType = Object.keys(this.dictData.NETWORK_SIGNIN_DETAILS);
            if (
                this.rowData.distributionLastFlag === 'Y' &&
                this.rowData.deliveryType === 'NET' &&
                netSignOrderType.includes(this.rowData.orderType) &&
                this.rowData.sourceSystem !== 'CAINIAO'
            ) {
                return true;
            }
            return false;
        },
        CNStateSubsidies () {
            return this.rowData.isSubsidies === '1';
        }
    },
    methods: {
        /**
         * @description 切换tab页
         */
        handleChangeView (component) {
            this.currentView = component;
        },
        /**
         * @description 获取左侧附件列表
         */
        getAttachmentList () {
            this.attachmentLoading = true;
            attachmentEntity.getAttachmentList(this.rowData.id).then(list => {
                this.attachmentList = list;
                this.attachmentList.forEach(item => {
                    item.aiResultName = item.aiResult ? this.dictData.TMS_AI_RESULT[item.aiResult] : '';
                    item.aiOverlapName = item.aiOverlap ? item.aiOverlap + '%' : '';
                    item.abnormalAiResultName = item.abnormalAiResult ? this.dictData.TMS_AI_RESULT[item.abnormalAiResult] : '';
                });
                this.$nextTick(() => {
                    this.$refs.receiptUpload.show();
                });
                if (this.CNStateSubsidies) {
                    // defineStr2: 普通照片--"0";SN码照片--"1";货物正面照--"2"
                    this.snUploadList = list.filter(item => item.defineStr2 === '1');
                    this.goodsUploadList = list.filter(item => item.defineStr2 === '2');
                    this.$nextTick(() => {
                        this.$refs.snUpload.show();
                        this.$refs.goodsUpload.show();
                    });
                }
            }).finally(() => { this.attachmentLoading = false; });
        },

        /**
         * @description 获取签收详情
         */
        getReceiptSignDetailInfo () {
            getReceiptSignDetailInfo({
                taskNo: this.rowData.taskNo // 运输单号
            }).then(res => {
                if (res && +res.code === 0) {
                    this.receiptInfo = Object.assign({}, { currentUserName: this.user.userName }, this.rowData, res.data);
                    this.$refs.signInForm.initFormData(this.receiptInfo);
                }
            }).finally(() => {
                this.getReceiptSignDetailList();
            });
        },

        /**
         * @description 获取签收详情列表
         */
        getReceiptSignDetailList () {
            queryReceiptDetailByTaskNo({ taskNo: this.rowData.taskNo }).then(res => {
                if (res && +res.code === 0) {
                    if (this.viewStatus === '1' && this.rowData.sourceSystem === 'OFC' && this.rowData.signStatus === SIGN_STATUS.SIGN_PENDING) {
                        const list = this.getDefaultInfoByWarehouseData(res.data.details);
                        this.goodsList = list;
                        this.tableDataList = list || [];
                    } else {
                        this.tableDataList = res.data.details || [];
                        this.goodsList = res.data.details || [];
                    }
                    this.viewStatus = res.data.customPilotType;
                }
            });
        },
        getReceiptSealByTaskNo () {
            queryByTaskNo(this.rowData.taskNo).then(res => {
                if (res && +res.code === 0 && res.data) {
                    const { signRequest, receiptType } = res.data;
                    this.receiptSealInfo = res.data;
                    this.receiptSealInfo.signRequest = signRequest ? signRequest.split(',') : [];
                    this.receiptSealInfo.receiptTypeName = this.dictData.RECEIPT_TYPE[receiptType + ''] || '';
                }
            });
        },
        /* 处理汇总变化 */
        getCount (data) {
            this.goodsList = data;
            this.$forceUpdate();
        },

        // 更新卸货费、上楼费标识
        changeFlag (data) {
            this.receiptInfo.unloadCharge = data.unloadCharge;
            this.receiptInfo.upstairsCharge = data.upstairsCharge;
        },

        /**
         * @description 图片上传成功回调
         */
        uploadReceiptImageSuccess () {
            this.getAttachmentList();
            this.$emit('uploadAttachmentSuccess');
        },

        /**
         * @description 删除图片成功回调
         */
        deleteReceiptImageSuccess () {
            this.getAttachmentList();
            this.$emit('deleteAttachmentSuccess');
        },
        /**
         * @description 违规卸货保存
         */
        handleIllegalUnload () {
            this.$refs.IllegalUnload.$refs.IllegalUnloadForm.validate((valid) => {
                if (valid) {
                    this.btnLoading = true;
                    const param = {
                        taskNo: this.rowData.taskNo,
                        ...this.$refs.IllegalUnload.IllegalUnloadForm
                    };
                    illegalUnloadUpdate(param)
                        .then(res => {
                            if (res && +res.code === 0) {
                                this.$message.success('保存成功');
                                this.$emit('success', 'signInShow');
                            }
                        })
                        .finally(() => {
                            this.btnLoading = false;
                        });
                }
            });
        },
        /**
         * @description 签收确认
         */
        handleSignComfirm () {
            const hasFail = validateSignComfirm(this.rowData);
            if (hasFail) return false;
            const componentName = this.componentChange[this.viewStatus];
            this.$refs[componentName].validateDataIsTrue().then(tableData => {
                this.btnLoading = true;
                const reqParams = formatSingleSignRequestParams(this.receiptInfo, tableData, OPERATE_TYPE.SIGN_COMFIRM);
                receiptSign([reqParams]).then(res => {
                    if (res) {
                        if (res.data.length > 0) {
                            this.$message.warning(res.data[0].message);
                        } else {
                            this.$message.success('签收成功');
                            this.$emit('success', 'signInShow');
                        }
                    }
                }).finally(() => {
                    this.btnLoading = false;
                });
            }).catch(({ message }) => {
                this.$message.warning(message);
            });
        },

        /**
         * @description 拒收确认
         */
        handleRejectComfirm () {
            const componentName = this.componentChange[this.viewStatus];
            this.$refs[componentName].validateDataIsTrue().then(tableData => {
                this.btnLoading = true;
                const reqParams = formatSingleSignRequestParams(this.receiptInfo, tableData, OPERATE_TYPE.REJECT_COMFIRM);
                reqParams.receiptSignDto.id = this.rowData.id; // 当前操作行数据id
                reqParams.rejectReason = ''; // 拒收原因 暂时传空
                reqParams.signRemark = ''; // 拒收备注 暂时传空
                receiptRejectSign(reqParams).then(res => {
                    if (res && +res.code === 0) {
                        this.$message.success('拒收成功');
                        this.$emit('success', 'signInShow');
                    }
                }).finally(() => {
                    this.btnLoading = false;
                });
            }).catch(({ message }) => {
                this.$message.warning(message);
            });
        },

        /**
         * @description 重推确认
         */
        handleSignPushComfirm () {
            const componentName = this.componentChange[this.viewStatus];
            this.$refs[componentName].validateDataIsTrue().then(tableData => {
                this.btnLoading = true;
                const reqParams = {
                    taskNo: this.rowData.taskNo,
                    receiptDetailDtos: tableData
                };
                signPush(reqParams).then(res => {
                    if (res && +res.code === 0) {
                        this.$message.success('重推成功');
                        this.$emit('success', 'signInShow');
                    }
                }).finally(() => { this.btnLoading = false; });
            }).catch(({ message }) => {
                this.$message.warning(message);
            });
        },

        /**
         * @description 增值费修改
         */
        handleChargeEdit () {
            this.btnLoading = true;
            const reqParams = {
                taskNos: [this.rowData.taskNo],
                unloadCharge: this.receiptInfo.unloadCharge,
                upstairsCharge: this.receiptInfo.upstairsCharge
            };
            updateCharge(reqParams)
                .then(res => {
                    if (res && +res.code === 0) {
                        this.$message.success('增值费修改成功');
                        this.$emit('success', 'signInShow');
                    }
                })
                .catch(() => { })
                .finally(() => { this.btnLoading = false; });
        },

        beforeClose () {
            this.$emit('update:signInShow', false);
        },
        /**
         * @description 获取入库数据
         */
        getWarehouseData () {
            this.signLoading = true;
            queryWarehouseData({ waybillNo: this.rowData.waybillNo }).then(res => {
                if (res && +res.code === 0) {
                    this.warehouseDataInfo = res.data;
                }
            }).finally(() => {
                this.initSignin();
                this.signLoading = false;
            });
        },
        initSignin () {
            this.getAttachmentList();
            this.getReceiptSealByTaskNo();
            this.getReceiptSignDetailInfo();
        },
        /**
         * @description 默认值赋值
         * @param {*} signDetailList
         */
        getDefaultInfoByWarehouseData (signDetailList) {
            if (!signDetailList.length) return [];
            const list = this.warehouseDataInfo.commodityDetail;
            // 当前操作为签收确认时， 赋默认值， 其他不操作， 只是显示
            if (list && list.length && this.dialogConfig.operateType === OPERATE_TYPE.SIGN_COMFIRM) {
                // 赋默认值， 按商品编码匹配
                signDetailList.forEach((k, v) => {
                    k.stockoutCount = this.getAllCount(k.itemCode, 'shortQty', list);
                    k.rejectQty = this.getAllCount(k.itemCode, 'rejectQty', list);
                });
            }
            return signDetailList;
        },
        /**
         * // 获取入库数据按商品编码汇总数据
         * @param {*} field
         * @param {*} targetField
         * @param {*} dataList
         */
        getAllCount (field, targetField, dataList) {
            const num = dataList.filter(item => item.itemCode === field).reduce((acc, cur) => {
                return acc + parseInt(cur[targetField] ? cur[targetField] : 0);
            }, 0);
            return num;
        },
        addListener() {
            this.$nextTick(() => {
                document.onkeydown = e => {
                    if (e.code === 'Escape') {
                        const receiptViewer = this.$refs.receiptUpload.viewer && this.$refs.receiptUpload.viewer.fulled;
                        const snViewer = this.$refs.snUpload && this.$refs.snUpload.viewer && this.$refs.snUpload.viewer.fulled;
                        const goodsViewer = this.$refs.goodsUpload && this.$refs.goodsUpload.viewer && this.$refs.goodsUpload.viewer.fulled;
                        const askViewer = this.$refs.signAsk && this.$refs.signAsk.sealViewer && this.$refs.signAsk.sealViewer.fulled;
                        const IllegalViewer = this.$refs.IllegalUnload && this.$refs.IllegalUnload.$refs.receiptUpload.viewer && this.$refs.IllegalUnload.$refs.receiptUpload.viewer.fulled;
                        if (!(receiptViewer || snViewer || goodsViewer || askViewer || IllegalViewer)) {
                            this.beforeClose();
                        }
                    }
                };
            });
        }
    },
    mounted () {
        this.addListener();
        if (this.rowData.sourceSystem === 'OFC') {
            this.getWarehouseData();
        } else {
            this.initSignin();
        }
    },
    unmounted() {
        // 移除事件监听器
        this.$nextTick(() => {
            document.onkeydown = null;
        });
    }
};
</script>
<style lang="less">
@import url('./signIn.less');
</style>
